import moment, { ISO_8601 } from 'moment';
import React, { FC } from 'react';
import { TaskDueDateChanged } from 'api/notifications/meta';
import { DueDate } from 'components/atoms/due-date';
import { useExternalIntegrationUserDetails } from 'hooks/use-external-integration-user-details';
import { useTranslation } from 'hooks/use-translation';
import { FieldChangedMessage } from './field-changed';

export const TaskDueDateChangedView: FC<{ meta: TaskDueDateChanged }> = ({
  meta: { by, from, to, externalUser },
}) => {
  const userDetails = useExternalIntegrationUserDetails(externalUser, by);

  return (
    <FieldChangedMessage
      name={useTranslation('fields.due_date')}
      by={userDetails}
      from={from ? <DueDate timestamp={moment(from.value, ISO_8601)} /> : null}
      to={to ? <DueDate timestamp={moment(to.value, ISO_8601)} /> : null}
    />
  );
};
